define('casino/casino-data',['module', 'jquery', 'all/interval-manager'], function (module, $, IntervalManager) {
	'use strict';
	var configuration = module.config();
	var casinoData = configuration.casinoData || {};

	function isMock() {
		return sessionStorage && sessionStorage.getItem('mock') === 'true';
	}

	function updateCasinoData() {
		var url = '/pp?flow=CasinoJson' + (isMock() ? '&mock=true' : '');
		$.getJSON(url, function (data) {
			casinoData = $.extend(true, casinoData, data);
		});
	}

	IntervalManager.setInterval(updateCasinoData, 2 * IntervalManager.MINUTE);

	if (isMock()) {
		updateCasinoData();
	}

	casinoData.updateCasinoData = updateCasinoData;
	return  casinoData;
});

